var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "viewsRatingStars" },
    [
      _vm._l(_vm.stars, function (star) {
        return _c(
          "span",
          { key: star, staticClass: "star", style: _vm.getStarStyle(star) },
          [_vm._v("★")]
        )
      }),
      _vm._v(" "),
      _c("span", { staticClass: "viewsRatingStars__rating" }, [
        _vm._v(_vm._s(_vm.rating > 0 ? _vm.rating.toFixed(1) : "-")),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }